import { useEffect, useState } from "react";

const links = [
  { label: "首页", href: "#top" },
  { label: "人气榜单", href: "#ranking" },
  { label: "热门精选", href: "#featured" },
  { label: "题材分类", href: "#categories" },
  { label: "新作速递", href: "#new" },
  { label: "关于漫潮", href: "#about" },
  { label: "联系我们", href: "#contact" },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 30);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const solid = scrolled || menuOpen;

  return (
    <header
      className={`fixed top-0 inset-x-0 z-50 transition-all duration-300 ${
        solid ? "bg-background-50/95 backdrop-blur-md shadow-sm border-b border-background-200/70" : "bg-transparent"
      }`}
    >
      <nav className="mx-auto max-w-7xl px-4 md:px-6 h-16 md:h-[72px] flex items-center justify-between">
        {/* logo */}
        <a href="#top" className="flex items-center gap-2 group">
          <span className="w-9 h-9 md:w-10 md:h-10 flex items-center justify-center rounded-xl bg-primary-500 text-background-50 font-display text-xl md:text-2xl">
            漫
          </span>
          <span className={`font-display text-xl md:text-2xl leading-none ${solid ? "text-foreground-950" : "text-white"}`}>
            漫潮
            <span className="ml-1 text-xs md:text-sm font-sans font-bold text-accent-500">精选榜</span>
          </span>
        </a>

        {/* desktop links */}
        <div className="hidden lg:flex items-center gap-1">
          {links.map((l) => (
            <a
              key={l.href}
              href={l.href}
              className={`px-3.5 py-2 text-sm font-medium rounded-full transition-colors whitespace-nowrap ${
                solid
                  ? "text-foreground-700 hover:text-primary-600 hover:bg-primary-50"
                  : "text-white/85 hover:text-white hover:bg-white/10"
              }`}
            >
              {l.label}
            </a>
          ))}
        </div>

        {/* actions */}
        <div className="flex items-center gap-2 md:gap-3">
          <a
            href="#ranking"
            className={`hidden md:inline-flex items-center gap-2 px-4 py-2.5 rounded-full text-sm font-bold whitespace-nowrap transition-colors ${
              solid
                ? "bg-primary-500 text-background-50 hover:bg-primary-600"
                : "bg-accent-500 text-foreground-950 hover:bg-accent-400"
            }`}
          >
            <i className="ri-fire-fill"></i>
            今日热榜
          </a>
          <button
            type="button"
            aria-label="打开导航菜单"
            onClick={() => setMenuOpen((v) => !v)}
            className={`lg:hidden w-10 h-10 flex items-center justify-center rounded-lg cursor-pointer transition-colors ${
              solid ? "text-foreground-900 hover:bg-background-100" : "text-white hover:bg-white/10"
            }`}
          >
            <i className={menuOpen ? "ri-close-line text-xl" : "ri-menu-line text-xl"}></i>
          </button>
        </div>
      </nav>

      {/* mobile menu */}
      {menuOpen && (
        <div className="lg:hidden bg-background-50 border-t border-background-200/70 px-4 pb-4 pt-2">
          <div className="flex flex-col gap-1">
            {links.map((l) => (
              <a
                key={l.href}
                href={l.href}
                onClick={() => setMenuOpen(false)}
                className="px-3 py-2.5 rounded-lg text-sm font-medium text-foreground-800 hover:bg-primary-50 hover:text-primary-700"
              >
                {l.label}
              </a>
            ))}
          </div>
        </div>
      )}
    </header>
  );
}